'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); // TODO should move this file to common


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _partial = require('transmute/partial');

var _partial2 = _interopRequireDefault(_partial);

var _Terms = require('self-service-api/constants/Terms');

var Terms = _interopRequireWildcard(_Terms);

var _CurrencySelectors = require('pricing-pages-unified-ui/selectors/CurrencySelectors');

var _CalculatorPriceDisplayTile = require('pricing-pages-unified-ui/components/calculator/CalculatorPriceDisplayTile');

var _CalculatorPriceDisplayTile2 = _interopRequireDefault(_CalculatorPriceDisplayTile);

var _SuiteCalcCTAsContainer = require('pricing-pages-unified-ui/components/growth-suite-page/SuiteCalcCTAsContainer');

var _SuiteCalcCTAsContainer2 = _interopRequireDefault(_SuiteCalcCTAsContainer);

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _PriceBreakdownModal = require('pricing-pages-unified-ui/components/calculator/PriceBreakdownModal');

var _PriceBreakdownModal2 = _interopRequireDefault(_PriceBreakdownModal);

var _Calculator = require('pricing-pages-unified-ui/components/calculator/Calculator');

var _pricingUtils = require('pricing-pages-unified-ui/utils/pricingUtils');

var _Hubs = require('self-service-api/constants/Hubs');

var _SuiteEditionMerchIdMap = require('pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap');

var _SuiteEditionMerchIdMap2 = _interopRequireDefault(_SuiteEditionMerchIdMap);

var _PricingSelectors = require('pricing-pages-unified-ui/selectors/PricingSelectors');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SuiteCalcPriceDisplayTileContainer = function SuiteCalcPriceDisplayTileContainer(_ref) {
  var _ref2;

  var activeCurrency = _ref.activeCurrency,
      pricingDependencies = _ref.pricingDependencies;

  var _useContext = (0, _react.useContext)(_Calculator.CalculatorContext),
      _useContext$state = _useContext.state,
      activeEdition = _useContext$state.activeEdition,
      activeTerm = _useContext$state.activeTerm,
      marketingUnits = _useContext$state.marketingUnits,
      salesUnits = _useContext$state.salesUnits,
      serviceUnits = _useContext$state.serviceUnits,
      selectedAddOns = _useContext$state.selectedAddOns,
      selectedServices = _useContext$state.selectedServices;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isModalVisible = _useState2[0],
      setModalVisibility = _useState2[1];

  var togglePriceBreakdown = function togglePriceBreakdown(isVisible) {
    setModalVisibility(isVisible);

    if (isVisible) {
      (0, _getUsageTracker2.default)().track('clickToViewModal', {
        name: 'price-breakdown-modal'
      });
    }
  };

  var pricingInfoParams = {
    marketingPlanSelected: _SuiteEditionMerchIdMap2.default[activeEdition][_Hubs.HUB_MARKETING],
    salesPlanSelected: _SuiteEditionMerchIdMap2.default[activeEdition][_Hubs.HUB_SALES],
    servicePlanSelected: _SuiteEditionMerchIdMap2.default[activeEdition][_Hubs.HUB_SERVICE],
    marketingUnits: marketingUnits,
    salesUnits: salesUnits,
    serviceUnits: serviceUnits,
    selectedAddOns: selectedAddOns,
    selectedServices: selectedServices,
    term: activeTerm,
    pricingDependencies: pricingDependencies,
    isGrowthSuite: true
  };

  var pricingInfo = (0, _pricingUtils.calculateBundlePrice)(pricingInfoParams);
  var allPriceBreakdowns = (0, _pricingUtils.getMultiplePriceBreakdowns)(pricingInfoParams);

  var recurringMerchPriceBreakdown = allPriceBreakdowns.filter(function (breakdown) {
    return breakdown.monthly.calculatedPrice !== 0;
  }).map(function (breakdown) {
    return {
      monthly: breakdown.monthly,
      annually: breakdown.annually
    };
  });

  var oneTimeMerchPriceBreakdown = allPriceBreakdowns.filter(function (breakdown) {
    return breakdown.oneTimeFee.calculatedPrice !== 0;
  }).map(function (breakdown) {
    return breakdown.oneTimeFee;
  });

  var getCostToGetStarted = function getCostToGetStarted() {
    var oneTimeFee = pricingInfo.oneTimeFee.calculatedPrice;
    switch (activeTerm) {
      case Terms.MONTHLY:
        return pricingInfo.monthly.calculatedPrice + oneTimeFee;
      case Terms.ANNUAL:
        return pricingInfo.annually.calculatedPrice + oneTimeFee;
      default:
        return null;
    }
  };

  var getFullCostToGetStarted = function getFullCostToGetStarted() {
    var oneTimeFee = pricingInfo.oneTimeFee.fullPrice;
    switch (activeTerm) {
      case Terms.MONTHLY:
        return pricingInfo.monthly.fullPrice + oneTimeFee;
      case Terms.ANNUAL:
        return pricingInfo.annually.fullPrice + oneTimeFee;
      default:
        return null;
    }
  };

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(_CalculatorPriceDisplayTile2.default, {
      gaTrackingId: 'growth',
      activeTerm: activeTerm,
      monthlyCost: pricingInfo.monthly.calculatedPrice,
      activeCurrencyCode: activeCurrency,
      onViewPriceBreakdownClick: (0, _partial2.default)(togglePriceBreakdown, true),
      costToGetStarted: getCostToGetStarted(),
      ctasComponent: _react2.default.createElement(_SuiteCalcCTAsContainer2.default, {
        edition: activeEdition,
        term: activeTerm,
        additionalUnitQuantities: (_ref2 = {}, _defineProperty(_ref2, _Hubs.HUB_MARKETING, marketingUnits), _defineProperty(_ref2, _Hubs.HUB_SALES, salesUnits), _defineProperty(_ref2, _Hubs.HUB_SERVICE, serviceUnits), _ref2)
      })
    }),
    isModalVisible && _react2.default.createElement(_PriceBreakdownModal2.default, {
      onCloseClick: (0, _partial2.default)(togglePriceBreakdown, false),
      estimatedCostToGetStarted: getCostToGetStarted(),
      fullCostToGetStarted: getFullCostToGetStarted(),
      activeTerm: activeTerm,
      activeEdition: activeEdition,
      pricingInfo: pricingInfo,
      recurringMerchPriceBreakdown: recurringMerchPriceBreakdown,
      oneTimeMerchPriceBreakdown: oneTimeMerchPriceBreakdown,
      isGrowthSuite: true
    })
  );
};

SuiteCalcPriceDisplayTileContainer.propTypes = {
  activeCurrency: _react.PropTypes.string.isRequired,
  pricingDependencies: _react.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    activeCurrency: (0, _CurrencySelectors.activeCurrencySelector)(state),
    pricingDependencies: (0, _PricingSelectors.pricingDependenciesSelector)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SuiteCalcPriceDisplayTileContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-page/SuiteCalcPriceDisplayTileContainer.js
// module id = 780
// module chunks = 3 4